<template>
  <label class="flex cursor-pointer items-start gap-2.5">

    <!-- Circle custom checkbox -->
    <template v-if="shape === 'circle'">

      <input type="checkbox" :checked="checked" class="sr-only"
        @change="$emit('update:checked', ($event.target as HTMLInputElement).checked)" />

      <div class="mt-0.5 h-5 w-5 pe-[0.3px] shrink-0 border rounded-full flex items-center justify-center duration-200"
        :class="checked
          ? 'bg-primary border-primary text-white'
          : 'bg-transparent border-border text-primary'">

        <svg v-if="checked" width="9" height="10" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.89594 9.24004C1.89594 9.13604 1.87594 9.08404 1.83594 9.08404L1.55994 9.21604C1.55994 9.16004 1.52794 9.12004 1.46394 9.09604L1.36794 9.08404C1.30394 9.08404 1.22394 9.11204 1.12794 9.16804C1.11194 9.12804 1.09194 9.08804 1.06794 9.04804C1.04394 9.00804 1.02394 8.97204 1.00794 8.94004C0.90394 8.74004 0.79994 8.52004 0.69594 8.28004C0.599939 8.03204 0.507939 7.79604 0.419939 7.57204C0.33994 7.34804 0.275939 7.17204 0.227939 7.04404C0.195939 6.94004 0.159939 6.78404 0.11994 6.57604C0.0799395 6.36804 0.0399395 6.10404 -6.05136e-05 5.78404C0.0879395 5.84004 0.155939 5.86804 0.203939 5.86804C0.259939 5.86804 0.311939 5.78404 0.359939 5.61604C0.38394 5.64804 0.42794 5.66404 0.49194 5.66404C0.53994 5.66404 0.57594 5.64804 0.599939 5.61604L0.79194 5.32804L1.00794 5.40004H1.01994C1.03594 5.40004 1.05194 5.39204 1.06794 5.37604C1.08394 5.36004 1.10794 5.34404 1.13994 5.32804C1.20394 5.28804 1.25194 5.26804 1.28394 5.26804L1.31994 5.28004C1.51994 5.37604 1.64794 5.55204 1.70394 5.80804C1.84794 6.41604 1.99194 6.72004 2.13594 6.72004C2.27994 6.72004 2.44794 6.56804 2.63994 6.26404C2.73594 6.11204 2.83194 5.93604 2.92794 5.73604C3.03194 5.53604 3.13594 5.31204 3.23994 5.06404C3.25594 5.16004 3.27194 5.20804 3.28794 5.20804C3.32794 5.20804 3.39594 5.10804 3.49194 4.90804C3.59594 4.70804 3.75994 4.43204 3.98394 4.08004C4.11194 3.86404 4.27194 3.62004 4.46394 3.34804C4.66394 3.07604 4.87594 2.79604 5.09994 2.50804C5.32394 2.22004 5.53994 1.94804 5.74794 1.69204C5.96394 1.43604 6.15594 1.21604 6.32394 1.03204C6.49194 0.848036 6.61594 0.728036 6.69594 0.672036C6.99994 0.464036 7.23994 0.264036 7.41594 0.0720358C7.40794 0.128036 7.39594 0.180036 7.37994 0.228036C7.37194 0.268036 7.36794 0.296036 7.36794 0.312036C7.36794 0.344036 7.38394 0.360036 7.41594 0.360036L7.75194 0.192036V0.240036C7.75194 0.304036 7.76794 0.336036 7.79994 0.336036C7.82394 0.336036 7.87194 0.300036 7.94394 0.228036C8.01594 0.156036 8.05594 0.104036 8.06394 0.0720358L8.03994 0.240036L8.44794 3.60012e-05L8.35194 0.216036C8.47994 0.128036 8.57194 0.0840356 8.62794 0.0840356C8.65994 0.0840356 8.68394 0.104036 8.69994 0.144036C8.71594 0.176036 8.72394 0.208036 8.72394 0.240036C8.72394 0.288036 8.70394 0.344036 8.66394 0.408036C8.62394 0.472036 8.57194 0.548036 8.50794 0.636036C8.45994 0.700036 8.37994 0.796036 8.26794 0.924036C8.16394 1.04404 8.00394 1.22404 7.78794 1.46404C7.57194 1.69604 7.28394 2.02004 6.92394 2.43604C6.82794 2.54004 6.67994 2.72404 6.47994 2.98804C6.27994 3.24404 6.05194 3.54404 5.79594 3.88804C5.54794 4.22404 5.29994 4.56404 5.05194 4.90804C4.80394 5.25204 4.58394 5.56404 4.39194 5.84404C4.19994 6.11604 4.06394 6.32004 3.98394 6.45604L3.23994 7.71604C3.07994 7.98804 2.94794 8.21204 2.84394 8.38804C2.73994 8.55604 2.65994 8.67204 2.60394 8.73604C2.48394 8.88004 2.35194 9.00804 2.20794 9.12004L2.09994 9.06004L2.00394 9.12004L1.89594 9.24004Z"
            fill="currentColor" />
        </svg>

      </div>

    </template>


    <!-- Default checkbox -->
    <template v-else>

      <input type="checkbox" :checked="checked"
        class="mt-0.5 h-5 w-5 shrink-0 cursor-pointer rounded-md border-2 border-border accent-primary"
        @change="$emit('update:checked', ($event.target as HTMLInputElement).checked)" />

    </template>


    <span class="text-sm leading-relaxed">
      <slot />
    </span>

  </label>
</template>


<script setup lang="ts">
withDefaults(
  defineProps<{
    checked?: boolean
    shape?: 'circle' | 'default'
  }>(),
  {
    shape: 'default',
  }
)

defineEmits<{
  'update:checked': [value: boolean]
}>()
</script>